import React from 'react';
import ContactSection from '../components/ContactSection';

export default function ContactPage() {
  return (
    <section className="page-section">
      <div className="page-hero">
        <span className="page-hero-label">Contact</span>
        <h1>Connect With <span>Our Team</span></h1>
        <p>
          Reach Laftek Business Solutions for placement support, upskilling guidance, interview preparation,
          and career-focused assistance.
        </p>
      </div>
      <ContactSection />
    </section>
  );
}
